import React, { useState } from 'react';
import { WDialog } from '../../wrappers/wrapper';
import { Tooltip, Typography } from '@mui/material';
import Button from 'components/atoms/button/button';
import CloseIcon from '@mui/icons-material/Close';
import styles from './youtube-dialog.module.scss';
import Input from 'components/molecules/input/input';

interface YoutubeDialogProps {
  open: boolean;
  onClose: (id?: string) => void;
}

const YoutubeDialog: React.FC<YoutubeDialogProps> = ({ open, onClose }) => {
  const [youtubeId, setYoutubeVideoId] = useState('');

  return (
    <WDialog open={open}>
      <div className={styles.youtubeDialog}>
        <div className={styles.header}>
          <Typography variant="h6" className={styles.text}>
            Youtube Video
          </Typography>
          <Tooltip title="Close" onClick={() => onClose(youtubeId)}>
            <CloseIcon fontSize="small" />
          </Tooltip>
        </div>
        <div className={styles.content}>
          <Input
            placeholder="Youtube video id"
            value={youtubeId}
            onChange={(e) => setYoutubeVideoId(e.target.value)}
          />
          <Button type={'primary'} radius="2rem" onClick={() => onClose(youtubeId)}>
            Save
          </Button>
        </div>
      </div>
    </WDialog>
  );
};

export default YoutubeDialog;
